<template>
  <div>
    <b-card class="standardpage reports border-none px-0 mx-0 lowpadding">
      <b-card-header class="px-0 mx-0">
        <b-row>
          <b-col cols="12" class="text-right text-sm-left pt-1">
            <i :class="ticketszhold.icon" class="mr-1"></i>
            <span class="text-primary"
              >Your {{ ticketszhold.sheet }} tickets
            </span>
          </b-col>
        </b-row>

        <b-tooltip target="refresh" triggers="hover"
          >Click to refresh</b-tooltip
        >
      </b-card-header>

      <b-row no-gutters class="mt-2">
        <b-col cols="12" sm="6" md="4" xl="3" class="ml-auto">
          <b-form-group label-cols="3" label="Agent:" label-size="sm" class="label-inline">
            <treeselect placeholder="Select user..." searchPromptText="Type at least 3 chars..." v-model="agent"
              :clearable="true" :async="true" :load-options="treeselect_loadUser" :show-count="true"
              :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested
              @select="treeselect" :disabled="!user.permissions.includes('zhold.admin')">
                      
              <div slot="value-label" slot-scope="{ node }">
                {{ node.raw.id }}
              </div>
            </treeselect>
          </b-form-group>
        </b-col>
      </b-row>

      <div v-if="!component" class="availtable datatable small">
        <!-- <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Date Order"
                  label-size="sm"
                >
                  <b-input-group>
                    <daterangepicker
                      size="sm"
                      ref="dateplaced"
                      v-model="dateplaced_at"
                      :opens="'right'"
                      :locale-data="locale_data"
                      :ranges="locale_ranges"
                      :linkedCalendars="true"
                    >
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="
                          dateplaced = {
                            startDate: null,
                            endDate: null,
                          }
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Your Ref / PO"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="yourref"
                      :debounce="ticketszhold.debounce"
                      placeholder="Your Ref"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!yourref"
                        @click="yourref = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect
                    placeholder="Select status..."
                    v-model="status"
                    :clearable="true"
                    :options="status_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                    :disabled="readonly"
                  >
             
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect
                    placeholder="Select event..."
                    searchPromptText="Type at least 4 chars..."
                    v-model="eventcode"
                    :multiple="true"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadEvent"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="agent"
                      :debounce="ticketszhold.debounce"
                      placeholder="Agent"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!agent"
                        @click="agent = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card> -->
        <div id="ticketszhold" class="px-0 mx-0 text-left">
          <d-table
            classdivtable="availtable datatable sheets"
            refid="ticketszhold"
            :icon="ticketszhold.icon"
            :tools="ticketszhold.tools"
            :toolbarlibrary="ticketszhold.toolbarlibrary"
            :toolbarinit="ticketszhold.toolbarinit"
            :badges="ticketszhold.badges"
            :fields="ticketszhold.fields"
            :items="ticketszhold.items"
            :busy="ticketszhold.busy"
            :showpages="false"
            @load="ticketszhold_load" 
            @click="ticketszhold_click"
            @select="ticketszhold_select"
          >
          </d-table>
        </div>
      </div>

      <!-- <div v-if="component">
        <component
          :is="component"
          :selection="selected"
          :config="cconfig"
          @discard="ticketszhold_click('discard')"
          @refresh="ticketszhold_click('refresh')"
        ></component>
      </div> -->
    </b-card>
    <!-- <Sidebardocuments
      :search="search"
      @discard="discard(row)"
      @refresh="refresh()"
    /> -->
  </div>
</template>
<script>
import gql from "graphql-tag";


export default {
  name: "TicketsZhold",

  mounted() {
    this.agent = this.user.email
  },
  data() {
    return {
      busy: false,
      agent: "",
      initials: "",
      ticketszhold: {
        title: "Your Tickets",
        icon: "fa fa-ticket text-orange",
        debounce: 500,
        busy: false,
        page: 1,
        sheet: "zhold",
        tools: "go,export",
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-warning",
            squared: "squared",
            icon: "fa fa-ticket text-warning",
            position: "sheets",
            action: "zhold",
            label: "z-hold",
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-danger",
            squared: "squared",
            icon: "fa fa-ticket text-danger",
            position: "sheets",
            action: "invalid",
            label: "invalid",
          },
        ],
        toolbarinit: "zhold,invalid",
        fields: [
          // {
          //   key: "selected",
          //   label: "...",
          //class: "text-center w-25px",
          // },
          {
            key: "icon",
            label: "",
            class: "w-50px text-right text-danger nowrap",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "",
          },
          {
            key: "ticketno",
            label: "TicketNo",
            sortable: true,
            class: "",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "passenger",
            label: "Passenger",
            class: "text-left",
            sortable: true,
            // formatter: (value, key, item) => {
            //   let result = value;
            //   if (value.length >= 20) {
            //     result = value.slice(0, 17) + " ...";
            //   }
            //   return result;
            // },
          },
          {
            key: "flightno",
            label: "FlightNo",
            class: "text-center",
            sortable: true,
          },
          {
            key: "class",
            label: "Class",
            class: "text-center",
            sortable: true,
          },
          {
            key: "routing",
            label: "Routing",
            class: "text-center",
            sortable: true,
          },
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "",
            totalled: true,
            total: 0,
          },
        
          {
            key: "dateissued",
            label: "Issued",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
        ],
        badges: [],
        items: [],
        selected: [],
      },
    };
  },
  watch: {
    agent: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          await this.agentinitials(newVal)
        } else {
          this.initials = this.user.initials
        }
      }
    },
    initials: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          await this.ticketszhold_load()
        }
      }
    }
  },
  methods: {
    async agentinitials(email) {
      let variables = {
        email,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query users_mssql($email: String) {
              users_mssql(email: $email) {
                id
                initials
              }
            }
          `,
          variables,
        });
        if (response.data.users_mssql.length > 0) {
          this.initials = response.data.users_mssql[0].initials
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ticketszhold_load(offset, limit) {
      this.ticketszhold.busy = true;
      this.ticketszhold.items = [];

      let variables = {
        mssql:false,
        dateissued: [
          this.$moment().startOf("month").format("YYYY-MM-DD"),
          this.$moment().format("YYYY-MM-DD"),
        ],
        orderby: [["slac", ""], ["[description]", "asc"],["[travel_at]", "asc"]],
        agent: this.initials,
        isvoid: false,
      };
      switch (this.ticketszhold.sheet) {
        case "zhold":
          variables.iszhold = true;
          break;
        case "invalid":
          variables.invalid = true;
          break;
      }
      console.log("zhold variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $mssql: Boolean
              $dateissued: [String]
              $agent: String
              $isvoid: Boolean
              $invalid: Boolean
              $iszhold: Boolean
              $orderby: [[String]]
            ) {
              tickets(
                mssql: $mssql
                dateissued: $dateissued
                agent: $agent
                isvoid: $isvoid
                invalid: $invalid
                iszhold: $iszhold
                orderby: $orderby
              ) {
                id
                dateissued
                ticketno
                fare
                tax
                locator
                slac
                passenger
                datetravel
                flightno
                class
                routing
                eventcode
                agent
                rows
              }
            }
          `,
          variables,
        });
        this.ticketszhold.items = response.data.tickets;
      } catch (error) {
        console.log(error);
      }
      this.ticketszhold.busy = false;
    },
    async ticketszhold_click(a, ss) {

      let state = this.ticketszhold;

      switch (a) {

        case "go":
          this.component = null;
          //   this.dateSelector();
          await this.ticketszhold_load();
          break;

      }
    },
    async ticketszhold_select(ss, tools) {
      console.log("seats_select", ss);

      let state = this.ticketszhold;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export", "seat_hk", "seat_ss"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      if (state.selected.length > 0) {
        state.item = state.selected[0]; // WHAT YOU SELECTED
      } else {
        state.item = {}
      }
    },
  },
};
</script>

<style>

</style>